import { writtenContentRoutes } from "@/modules/writtenContent/routes";

export const productsRouteBasePath = "products";

export const productRoutesNames = {
  root: "products",
  list: () => `${productRoutesNames.root}.list`,
  details: () => `${productRoutesNames.root}.details`,
  writtenContentTab: () => `${productRoutesNames.root}.written-content`,
  richContentTab: () => `${productRoutesNames.root}.rich-content`,
};

export const productsRoutes: any = [
  {
    name: productRoutesNames.root,
    path: productsRouteBasePath,
    component: () => import("@/modules/products/views/layouts/Default.vue"),
    meta: {
      auth: true,
      scope: "products:read",
      scrollTop: true,
    },
    children: [
      {
        path: "",
        name: productRoutesNames.list(),
        component: () => import("@/modules/products/views/ProductsList.vue"),
      },
      {
        path: `:productId`,
        name: productRoutesNames.details(),
        component: () => import("@/modules/products/views/ProductDetails.vue"),
      },
      {
        path: ":productId/written-content",
        name: productRoutesNames.writtenContentTab(),
        component: () => import("@/modules/products/views/ProductDetails.vue"),
        meta: {
          scope: "contents:written_content:read",
        },
      },
      {
        path: ":productId/rich-content",
        name: productRoutesNames.richContentTab(),
        component: () => import("@/modules/products/views/ProductDetails.vue"),
        meta: {
          scope: "contents:rich:read",
        },
      },
    ],
  },
  ...writtenContentRoutes(productsRouteBasePath),
];
